import { Component, OnInit } from '@angular/core';
import { select } from '@angular-redux/store';
import { Observable } from 'rxjs/Observable';
import { Lab } from '../../../contracts/lab/lab.model';

@Component({
  selector: 'mc-current-lab',
  templateUrl: './current-lab.component.html'
})
export class CurrentLabComponent implements OnInit {
  @select(['labState', 'currentLab']) currentLab$: Observable<Lab>;

  constructor() { }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/template/current-lab/current-lab.component.ts